<template>
  <div class="sy-pur-line-type-edit-wrap">
    <el-select
      v-bind="$attrs"
      v-on="$listeners"
      v-model="code"
      @change="selectChange"
      @clear="clearHandle"
      filterable
      clearable
    >
      <el-option
        v-for="item in purLineTypeList"
        :key="item.code"
        :label="item.name"
        :value="item.code"
      >
        <span>{{ selectLabel(item) }}</span>
      </el-option>
    </el-select>
  </div>
</template>

<script>
// import SySelect from "../../../basis/select"
// import SyOption from "../../../basis/option"
import Api from "./api"
import response from "../../../../utils/response/index.js"
import { componentMessage } from "../../utils"

export default {
  name: "pur-line-type-edit",
  components: {
    // SySelect,
    // SyOption,
  },
  data() {
    return {
      purLineTypeList: [],
      isClear: false // 是否主动清空（清空事件&无效数据主动清空）
    }
  },
  props: {
    // 是否需要获取默认值
    isDefault: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: ''
    },
    materialId: [Number, String], // 物料id
    materialCategoryId: [Number, String], // 物料分类id
  },
  computed: {
    info () {
      let obj = {
        materialId: this.materialId,
        materialCategoryId: this.materialCategoryId
      }
      return obj
    }
  },
  watch: {
    // 是否请求默认值 物料主数据>物料分类-末级分类>系统配置-基础数据配置
    info: {
      deep: true,
      handler (val) {
        if ((val.materialId || val.materialCategoryId) && this.isDefault) {
          this.getPurLineTypeDefault()
        }
      }
    },
    code: {
      immediate: true,
      handler (nVal, oVal) {
        if (nVal && !oVal) {
          this.isClear = false
          this.getEffectiveByCode()
        } else if (!this.isClear && !nVal && this.isDefault) {
          this.getPurLineTypeDefault()
        }
      }
    }
  },
  async created() {
    // 适用于商城端和采购商端
    let flag = componentMessage(
      ["mall", "purchaser"],
      "pur-line-type 采购行类型"
    )
    if (flag) return
    this.getPurLineTypeList()
  },
  methods: {
    selectLabel(item) {
      return `${item.name}  ${item.receiveTypeName}/${item.purchaseTypeName}`
    },
    async selectChange(val) {
      this.$emit("update:code", val)
      let selectedOptions = this.purLineTypeList.find(item => {return  item.code === val})
      this.$emit("changeVal", val, selectedOptions)
    },
    clearHandle () {
      this.isClear = true
      this.$emit("clearVal")
    },
    // 获取采购行类型列表
    async getPurLineTypeList() {
      const api = Api.listEffective
      const res = await response(this.$http(api.type, api.url))
      if (res.isOk) {
        this.purLineTypeList = res.content || []
      }
    },
    // 获取采购行类型是否有效
    async getEffectiveByCode() {
      const api = Api.getEffectiveByCode
      const res = await response(this.$http(api.type, api.url, {code: this.code}))
      if (res.isOk) {
        if (res.content) {
          return 
        }
        this.isClear = true
        this.code = ''
        this.$emit("update:code", this.code)
      }
    },
    // 获取采购行默认值
    async getPurLineTypeDefault() {
      const api = Api.getDefault
      const params = {
        materialId: this.materialId,
        materialCategoryId: this.materialCategoryId
      }
      const res = await response(this.$http(api.type, api.url, params))
      if (res.isOk) {
        this.code = res.content.code || ''
        this.$emit("update:code", this.code)
      }
    },
  },
}
</script>

<style scoped lang="scss">
</style>
